module.exports = __webpack_public_path__ + "static/media/pdf-placeholder.82fb7bde.png";